export default "__VITE_ASSET__CvZxpulm__"